import { push } from "connected-react-router";
import React from "react";
import { useDispatch } from "react-redux";

const HeaderBar = () => {
  const dispatch = useDispatch();
  return (
    <>
      <div className="header-container">
        <div className="header-container__detail--inner">
          <div onClick={() => dispatch(push("/boothlist"))} className="header-container__detail--text hover1">
            EXIT
          </div>
        </div>
      </div>
      <div className="header-container__detail--foundation"></div>
    </>
  );
};

export default HeaderBar;
